module.exports = __webpack_public_path__ + "img/BannerCompatibilidad700x250.01bbf8b3.jpg";